import React, { useEffect, useState } from "react";
import { Button, Col, Divider, message, Modal, Row, Spin, Tooltip, Upload } from "antd";
import axios from "axios";
import uniqueId from "lodash/uniqueId";
import moment from "moment";
import { ReactComponent as FileIcon } from "../../img/shape.svg";
import { ReactComponent as UploadFileIcon } from "../../img/add-file.svg";
import { ReactComponent as DeleteFileIcon } from "../../img/delete-file-icon.svg";
import {
  createContentFileData,
  createContentMetaData,
  deleteContentFileData,
} from "../../lib/routes/dictionaries";
import { useAppSelector } from "../..";

interface FileItem {
  id: number;
  contentName: string;
  contentTypeId: number;
  sourceObjectTypeId: null;
  sourceObjectId: null;
  createDate: string;
  dsc: null;
  tenantId: number;
}

interface IProps {
  files: FileItem[];
  onChageLoadFile?: (files: FileItem[]) => void;
}

function FilesList({ files, onChageLoadFile }: IProps) {
  const [deletedFile, setDeletedFile] = useState<{ name: string; id?: number }>({ name: "" });
  const [loadingData, setLoadingData] = useState<boolean>(false);
  const [filesDownload, setFilesDownload] = useState<FileItem[]>();

  useEffect(() => {
    setFilesDownload(files);
  }, [files]);

  const { tenant } = useAppSelector((state) => state.tenants);

  const renderAttachments = () => {
    const filesList = filesDownload?.map((file) => {
      const fileName = file?.contentName?.replace("/files/", "");

      return (
        <Col
          key={uniqueId()}
          style={{ paddingLeft: 0, paddingRight: 0, paddingTop: 6, marginRight: "-15px" }}
        >
          <Tooltip title="Удалить файл">
            <DeleteFileIcon
              style={{
                cursor: "pointer",
                position: "relative",
                top: "-37px",
                left: "36px",
                zIndex: 1,
              }}
              onClick={() => {
                setDeletedFile({ name: fileName, id: file?.id });
              }}
            />
          </Tooltip>
          <FileIcon title={fileName} />
        </Col>
      );
    });

    const acceptedTypes =
      ".jpg, .jpeg, .png, .pdf, .rtf, .doc, .docx, msword, vnd.openxmlformats-officedocument.wordprocessingml.document, .xls, .xlsx, vnd.openxmlformats-officedocument.spreadsheetml.sheet, vnd.ms-excel";

    const uploadFiles = ({ file }) => {
      if (file.originFileObj !== undefined) {
        const formData = new FormData();
        formData.append("/file", file.originFileObj);
        setLoadingData(true);

        axios
          .post(createContentMetaData(), {
            contentName: file?.name,
            createDate: moment().format(),
            contentTypeId: 1,
            tenant: tenant?.id,
          })
          .then((response) => {
            if (response?.data?.id) {
              axios
                .put(createContentFileData(response?.data?.id), formData, {
                  headers: { "Content-Type": "multipart/form-data" },
                })
                .then(() => {
                  message.destroy();
                  message.success("Файл добавлен", 3);

                  const newFiles = filesDownload
                    ? [...filesDownload, { ...response?.data }]
                    : [{ ...response?.data }];

                  onChageLoadFile && onChageLoadFile(newFiles);
                  setLoadingData(false);
                })
                .catch((error) => {
                  axios.delete(deleteContentFileData(response?.data?.id));
                  message.destroy();
                  message.error(
                    <>
                      <div>При загрузке файла возникла ошибка.</div>
                      <div>Пожалуйста, повторите попытку позднее</div>
                    </>,
                    3
                  );
                  setLoadingData(false);
                });
            }
          })
          .catch(() => {
            message.destroy();
            message.error(
              <>
                <div>При загрузке файла возникла ошибка.</div>
                <div>Пожалуйста, повторите попытку позднее</div>
              </>,
              3
            );
            setLoadingData(false);
          });
      }
    };

    return (
      <div style={{ backgroundColor: "white", width: "100%" }}>
        <Row gutter={20}>
          {filesList}
          <Upload
            accept={acceptedTypes}
            multiple
            showUploadList={false}
            customRequest={() => {}}
            onChange={uploadFiles}
          >
            <UploadFileIcon
              style={{
                cursor: "pointer",
                marginLeft: filesList && filesList.length > 0 ? "5px" : "4px",
              }}
            />
          </Upload>
        </Row>
      </div>
    );
  };

  const renderDeleteFileModal = () => {
    const handleCloseModal = () => {
      setDeletedFile({ name: "" });
    };
    const handleDelete = (id) => {
      setLoadingData(true);
      axios
        .delete(deleteContentFileData(id))
        .then(() => {
          message.destroy();
          message.success("Файл удален");

          const newFiles = filesDownload?.filter((el) => el.id !== id) || [];

          onChageLoadFile && onChageLoadFile(newFiles);
        })
        .catch(() => {
          message.error(
            <>
              <div>При удалении файла возникла ошибка.</div>
              <div>Пожалуйста, повторите попытку позднее</div>
            </>,
            3
          );
        })
        .finally(() => {
          handleCloseModal();
          setLoadingData(false);
        });
    };
    return (
      <Modal
        visible={Boolean(deletedFile.name)}
        width="690px"
        footer={null}
        onCancel={handleCloseModal}
      >
        <h2>Удаление файла</h2>
        <Divider className="thin-divider" style={{ marginTop: 10 }} />
        <div>Вы действительно хотите удалить выбранный файл: {deletedFile.name}?</div>
        <Row gutter={20} style={{ marginTop: 20, marginBottom: 10 }}>
          <Col className="ml-auto">
            <Button onClick={handleCloseModal}>Отмена</Button>
          </Col>
          <Col className="mr-auto">
            <Button type="primary" onClick={() => handleDelete(deletedFile.id)}>
              Удалить
            </Button>
          </Col>
        </Row>
      </Modal>
    );
  };

  return (
    <Row>
      <Spin spinning={loadingData}>
        {renderDeleteFileModal()}
        {renderAttachments()}
      </Spin>
    </Row>
  );
}

export default FilesList;
